export enum SwapScreenNames {
  MAIN = 'swap-list',
  SWAP = 'swap',
}
